import { SET_ACTIVECONTENTTABINDEX, SET_ACTIVEOBJ, SET_LOGPERMISSION_FLAG, SET_POPUPFLAG, SET_ROUTE, SET_CURRENT_USER } from "./actionTypes";
import { SET_SETTING_FLAG } from "./actionTypes";


export const setRoute = (data) => ({
    type: SET_ROUTE,
    payload: data
});

export const setSettingFlag = (data) => ({
    type: SET_SETTING_FLAG,
    payload: data
})

export const setLoginPermissionFlag = (data) => ({
    type: SET_LOGPERMISSION_FLAG,
    payload: data
})

export const setActiveContentTabIndex = (data) => ({
    type: SET_ACTIVECONTENTTABINDEX,
    payload: data
})
export const setActiveObj = (data) => ({
    type: SET_ACTIVEOBJ,
    payload: data
})
export const setPopUpFlag = (data) => ({
    type: SET_POPUPFLAG,
    payload: data
})
export const setCurrentUser = (data) => ({
    type: SET_CURRENT_USER,
    payload: data
})